export enum RoleActionsTypes {
  "LIST_ROLE" = "LIST_ROLE"
}

export enum RoleMutationsTypes {
  "SET_ROLE" = "SET_ROLE"
}

export enum RoleGettersTypes {
  "ROLE_BY_ID" = "ROLE_BY_ID",
  "ROLE_ALL_ID" = "ROLE_ALL_ID"
}
